import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet-async';
import HeroSection from '../components/Hero'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import Card from '../components/Card'
import InfoSection from '../components/InfoSection'
import { homeObjOne, homeObjTwo, homeObjThree, homeObjFour } from '../components/InfoSection/Data'
import { InfoContainer3, InfoWrapper, TextImageSection, TextBlock, ImageBlock, ImageRow } from '../components/InfoSection/InfoElements'
import { useLocation } from "react-router-dom";


import img1 from '../images/nowe/1.png';
import img2 from '../images/nowe/2.png';
import img3 from '../images/nowe/3.png';
import img4 from '../images/nowe/main.png';


import img5 from '../images/nowe/cer_kontakt.png';
import img6 from '../images/nowe/cer_mowa.png';
import img7 from '../images/nowe/cer_ryt.png';
import img8 from '../images/nowe/cer_prow.png';
import img9 from '../images/nowe/cer_most.png';

import img10 from '../images/nowe/cer_1.png';

const Home = () => {
const location = useLocation();
    useEffect(() => {
  if (location.hash) {
    const id = location.hash.replace("#", "");
    // ⏱️ daj Reactowi chwilę na render sekcji
    setTimeout(() => {
      handleScroll(id);
    }, 100);
  }
}, [location]);

    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }

    const handleScroll = (id) => {
      const element = document.getElementById(id);
      const navbarHeight = 80; // dopasuj do swojego navbara w px
      if (element) {
        const y = element.getBoundingClientRect().top + window.scrollY - navbarHeight;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    };

    return (
        <>
        
            <Navbar toggle={toggle} />
            <Sidebar isOpen={isOpen} toggle={toggle} />
            <HeroSection />
            <InfoContainer3 lightBg='true'>
                <InfoWrapper>
                    <ImageRow>
                        <img src={img1}></img>
                        <img src={img2}></img>
                        <img src={img3}></img>
                    </ImageRow>
                    <div>
                    <TextImageSection>
                <TextBlock>
                    <h2>Obecność. Prawda. Życie.</h2>
                    <p>
To trzy wartości, które prowadzą mnie w każdym spotkaniu z drugim człowiekiem.                    </p>
<p>
    Obecność uzdrawia. Uczy delikatności wobec siebie i innych. To dzięki niej możliwe jest
prawdziwe przejście – z bólu ku zrozumieniu, z żalu ku pamięci.
</p>
<p>
Prawda pozwala zobaczyć, że śmierć nie jest końcem, a częścią większej całości.
Pomagam ludziom wracać do swojej prawdy o miłości, więzi i o tym, co naprawdę trwa.
</p>
<p>
Życie jest święte. W jego pulsie jest miłość, twórczość i oddech. Przypominam o nim zawsze
– nawet w obliczu straty.
</p>
<p>
Tworzę ceremonie pożegnań, które pamiętają o życiu.
</p>
<p>
W świecie, który rozwinął medycynę, technologię i psychologię, ale zapomniał o rytuałach –
przywracam ludziom to, co od tysięcy lat pomagało nam przechodzić przez granice między
światami.
</p>



                </TextBlock>
                <ImageBlock>
                    <img src={img4} alt="Atenida" />
                </ImageBlock>
    </TextImageSection>
    </div>
    <div>
    <p>
Rytuały są językiem duszy. Dają nam poczucie domknięcia, ale też otwarcia – pokazują, że
coś się kończy, ale coś innego może się zacząć.
</p>
    <p>
Dziś wiele pożegnań skupia się wyłącznie na śmierci, pozostawiając ludzi w poczuciu
beznadziei.
</p>
<p>
Ja przypominam, że za żalem stoi miłość, a za stratą – życie, które trwa.
</p>
<p>
W moich ceremoniach oddzielamy ciało od esencji człowieka, by uhonorować fizyczne
odejście, ale zachować to, co wciąż obecne – miłość, pamięć i energię życia.
</p>
<p>
To jest moja praca u podstaw – zmiana sposobu, w jaki jako ludzie żegnamy i pamiętamy.
</p>
<p>
A może raczej przypomnienie tego, co kiedyś już potrafiliśmy, ale o czym świat z czasem
zapomniał.
</p>
<p>
Ja dziś o tym przypominam – z czułością, świadomością i głębokim szacunkiem dla życia.
</p>
<p>
Bo tam, gdzie kończy się ciało, życie wciąż trwa.
</p>
<p>
    A w jego pulsie – jak zawsze – bije miłość.
</p>
</div>
<hr></hr>
<div id='jak'>
    <br></br>
<TextImageSection>
    <ImageBlock>
        <img src={img5} alt="Atenida" />
    </ImageBlock>
    <TextBlock>

<h2>Jak projektuję ceremonie?</h2>
<p>
    Każda ceremonia pamięci życia powstaje w oparciu o spotkanie i rozmowę.
Nie tworzę uroczystości na podstawie formularzy ani wiadomości e-mail.</p>
<p>Słucham historii, wspomnień i energii osoby, którą żegnamy – to z tej przestrzeni rodzi się
scenariusz, symbole i słowa, które naprawdę oddają jej istotę.</p>
<p>Każdy rytuał jest unikalny, osobisty i tworzony z czułością – tak, by ten dzień stał się
wspierającym przejściem, a nie tylko formalnością.
</p>
{/* <p>
<div onClick={() => handleScroll("more")} style={{ cursor: "pointer", color: "black" }}><b>👉Dowiedz się, jak powstaje ceremonia</b></div>
</p> */}
</TextBlock>
</TextImageSection>
</div>
{/*
<hr></hr>
 <div>
<h2>Skontaktuj się ze mną</h2>
<p>
Jeśli ktoś z Twoich bliskich odchodzi lub właśnie odszedł i potrzebujesz wsparcia w
organizacji osobistej, bliskiej sercu ceremonii pamięci życia,
zadzwoń lub napisz do mnie – pomogę Ci przejść przez ten proces z uważnością i
spokojem.</p>
<p><a href='tel:667 988 743' style={{ cursor: "pointer", color: "black", textDecoration: "none" }}>📞667 988 743</a></p>
<p><a href='mailto:ceremonie@atenita.pl' style={{ cursor: "pointer", color: "black", textDecoration: "none" }}>📧ceremonie@atenita.pl</a></p>
<p>Jestem również dostępna na WhatsAppie, jeśli wolisz krótką wiadomość lub szybkie
połączenie głosowe.
</p>
</div> */}

<div id="more">
    <TextImageSection>
        <TextBlock>
    <p>Każda ceremonia jest wyjątkowa – tak jak wyjątkowe jest życie osoby, której ciało żegnamy,
a której istota nadal trwa.</p>
<p>Wierzę, że pogrzeb to nie koniec, lecz święty rytuał przejścia, w którym oddzielamy ciało od
duszy i pozwalamy jej w miłości powrócić do źródła.</p>
<p>To moment, w którym łączymy to, co ziemskie, z tym, co wieczne.</p>
</TextBlock>
    <ImageBlock>
        <img src={img10} alt="Atenida" />
    </ImageBlock>
</TextImageSection>

<br></br>
<h3>1. Pierwszy kontakt i rozmowa</h3>
<p>Wszystko zaczyna się od spotkania – rozmowy z rodziną lub bliskimi osoby, której ciało
będziemy żegnać.</p>
<p>To czas, w którym słucham historii, wspomnień i emocji, ale też ciszy, w której kryje się
najwięcej znaczeń.</p>
<p>Nie proszę o wypełnianie formularzy – po prostu rozmawiamy, a ja wsłuchuję się w to, co
naprawdę ważne.</p>
<p>Wspólnie szukamy tonu ceremonii, który najpełniej odda ducha tej osoby i to, kim naprawdę
była.</p>
<p>Czasem jest to uroczystość spokojna i kontemplacyjna, a czasem pełna wdzięczności,
światła, kolorów, dźwięków, a nawet tańca – jeśli właśnie w ten sposób wyrażała się jej
radość życia.</p>
<p>To, jaki kształt przybierze ceremonia, zależy od bliskich, ich gotowości i wspólnej intencji, ale
przede wszystkim od esencji życia tej osoby – od tego, co kochała, czym się pasjonowała, w
co wierzyła.</p>
<p>Bywa, że ktoś już wcześniej pozostawił wskazówki dotyczące swojego pożegnania; innym
razem odkrywamy je wspólnie, słuchając historii i wspomnień, które niosą odpowiedzi.
Od pierwszego dnia rozmowy aż do dnia ceremonii pozostaję z rodziną w kontakcie i
wsparciu.</p>
<p>Dzięki mojemu psychologicznemu, coachingowemu i socjoterapeutycznemu przygotowaniu
potrafię towarzyszyć w sposób profesjonalny, bezpieczny emocjonalnie i pełen empatii.
Ten etap jest równie ważny jak sama uroczystość – to czas, który może stać się początkiem
łagodnego procesu przejścia przez doświadczenie straty, w sposób naturalny, świadomy i
pozbawiony dodatkowych napięć czy obciążeń wynikających z niepewności lub braku
wsparcia.</p>
<p>Delikatność, obecność i uważność sprawiają, że przygotowania stają się przestrzenią
stabilizacji i ukojenia, a nie dodatkowego stresu.</p>

<br></br>
<h3>2. Tworzenie scenariusza i rytuałów</h3>
<TextImageSection>
    <TextBlock>
<p>Na podstawie rozmów powstaje scenariusz ceremonii oraz zestaw rytuałów, które wspierają
proces przejścia – zarówno bliskich, jak i duszy osoby, której ciało żegnamy.</p>
<p>Rytuały mogą przybierać różne formy: zapalenie świecy, wspólne wypowiedzenie słów,
dźwięk dzwonka, symboliczny gest, zapach olejków, a czasem również praca z kamieniami
naturalnymi, półszlachetnymi lub szlachetnymi, które pomagają utrzymać energię i intencję
całej uroczystości.</p>
<p>Każdy rytuał tworzę intencjonalnie i świadomie – tak, by był zgodny z energią osoby zmarłej
i gotowością jej bliskich.</p>
<p>To język duszy, który pozwala objąć pełen wachlarz ludzkich emocji – od bólu, przez
wdzięczność i ulgę, aż po spokój, radość i poczucie ciągłości życia.</p>
</TextBlock>
    <ImageBlock>
        <img src={img7} alt="Atenida" />
    </ImageBlock>
</TextImageSection>

<p>Nie zakładam, jakie emocje się pojawią – stwarzam przestrzeń, w której każda z nich może
być obecna, bez oceny, z pełnym zrozumieniem i czułością.</p>
<p>Rytuały mają również funkcję porządkującą i integrującą – pomagają zharmonizować
energię przestrzeni, połączyć to, co ziemskie, z tym, co duchowe, i przywrócić wewnętrzną
równowagę zarówno uczestnikom, jak i samej ceremonii.</p>


<br></br>
<h3>3. Mowa pożegnalna i muzyka</h3>
<TextImageSection>
    <ImageBlock>
        <img src={img6} alt="Atenida" />
    </ImageBlock>
    <TextBlock>
<p>Mowa pożegnalna to serce ceremonii pamięci życia – opowieść o istocie człowieka, o jego
drodze, wartościach i miłości, która nie znika wraz z odejściem ciała.</p>
<p>Nie jest to biografia, ale żywa opowieść utkane z emocji, wspomnień i obecności.</p>
<p>Piszę ją z pełną uważnością i szacunkiem, tak aby słowa niosły spokój, prawdę i ciepło –
nawet wtedy, gdy dotykają tego, co trudne.</p>
<p>To moment, w którym można jeszcze raz poczuć obecność tej osoby – jej charakter, głos,
sposób bycia.</p>
<p>Równie ważna jak słowo jest muzyka – ona otwiera przestrzeń, w której można poczuć,
zamiast mówić.</p>
</TextBlock>
</TextImageSection>
<p>Wspólnie z bliskimi dobieramy dźwięki, które tworzą odpowiedni nastrój – czasem są to
utwory pełne światła i wdzięczności, innym razem melodie delikatne, kontemplacyjne lub te,
które zmarła osoba szczególnie kochała.</p>
<p>Muzyka staje się tłem, które łączy serca obecnych i pozwala im wejść w rytm wspólnego
doświadczenia.</p>
<p>Jeśli ceremonia odbywa się poza zakładem pogrzebowym, zapewniam również
profesjonalne nagłośnienie i mikrofon, dzięki czemu całość może przebiec spokojnie, bez
troski o stronę techniczną.</p>
<p>Dbam o każdy szczegół, aby słowa i dźwięki płynęły w harmonii – jak modlitwa bez religii,
jak rozmowa dusz ponad czasem.</p>

<h3>4. Prowadzenie ceremonii</h3>
<TextImageSection>
    <TextBlock>
<p>W dniu ceremonii tworzę bezpieczną, uważną przestrzeń, w której można być dokładnie z
tym, co się pojawia – ze łzami, ciszą, śmiechem, wdzięcznością, a czasem po prostu z
oddechem.</p>
<p>To moment, w którym ziemskie spotyka się z duchowym, a obecni mogą poczuć, że śmierć
nie kończy więzi, lecz nadaje jej inny kształt.</p>
<p>Podczas uroczystości prowadzę bliskich krok po kroku przez cały rytuał, w sposób naturalny
i łagodny.</p>
<p>Czuwam nad słowem, gestem, rytmem i energią przestrzeni – tak, by każdy element niósł
znaczenie i sens.</p>
</TextBlock>
    <ImageBlock>
        <img src={img8} alt="Atenida" />
    </ImageBlock>
</TextImageSection>
<p>Wspieram obecnych w przejściu przez emocje, pomagając im odnaleźć spokój, wdzięczność
i poczucie ciągłości życia.</p>
<p>Równocześnie pracuję na poziomie energetycznym i duchowym – z intencją, by dusza
mogła bezpiecznie przejść dalej, do źródła.</p>
<p>Słowa, które wypowiadam, i rytuały, które prowadzę, tworzą swego rodzaju pomost: między
światem widzialnym a tym, którego już nie widzimy, ale wciąż czujemy.</p>
<p>To subtelny, niewidoczny proces – jednak jego efekt można odczuć: harmonia, ukojenie,
wewnętrzna cisza, która pojawia się po zakończeniu uroczystości.</p>
<p>Kiedy w przestrzeni czuć spokój i ciepło, wiem, że ceremonia dopełniła się – że miłość
pozostała, tylko zmieniła formę.</p>
</div>

<hr></hr>
<div>
    <TextImageSection>
        <ImageBlock>
        <img src={img9} alt="Atenida" />
    </ImageBlock>
    <TextBlock>
    <p>Każda ceremonia pamięci życia jest mostem między światem widzialnym a tym, który trwa
dalej.</p>
<p>To spotkanie miłości, wdzięczności i prawdy o tym, że nic naprawdę nie znika – zmienia
jedynie swoją formę.</p>
<p>Wierzę, że pięknie i świadomie poprowadzony rytuał potrafi nie tylko uhonorować życie,
które się dopełniło, ale też przywrócić tym, którzy pozostali, spokój, sens i zaufanie do cyklu
istnienia.</p>
<p>W swojej pracy pamiętam, że Ziemia jest żywą istotą – że tak jak nasze ciało tworzą miliardy
mikroorganizmów, tak jej ciało tworzą ludzie, zwierzęta, rośliny, woda i kamienie.</p>

</TextBlock>
</TextImageSection>
<p>To, jaką energię zostawiamy podczas pożegnania ciała, ma znaczenie – wpływa na to, jak ta
większa całość oddycha i czuje.</p>
<p>Dlatego wierzę, że rytuał przejścia może być aktem troski nie tylko o człowieka, ale i o
Ziemię – że przestrzeń, w której składamy ciało, może zostać napełniona energią miłości,
wdzięczności i pokoju, a nie wyłącznie ciężarem żalu.</p>
<p>Każda ceremonia niesie w sobie pełen wachlarz emocji – od smutku po wdzięczność, od
ciszy po ciepło wspomnień.</p>

<p>To od słów, rytmu i obecności mistrza ceremonii zależy, czy te emocje ułożą się w
harmonijną całość.</p>
<p>Wierzę, że właśnie wtedy powstaje coś niezwykłego – delikatna nić światła, która łączy
serca żyjących, duszę odchodzącego i pulsującą świadomość Ziemi.</p>
<p>Bo w tym, co najważniejsze – życie zawsze trwa.</p>
</div>
<hr></hr>
<div>
    <b>
<p>
    Wybierając osobę, która poprowadzi ceremonię, kieruj się sercem.
Zwróć uwagę na jej wrażliwość, wartości i estetykę — niech będą bliskie Twoim.</p>
<p>To daje spokój i poczucie bezpieczeństwa, że tak ważny moment oddajesz w ręce kogoś,
komu naprawdę możesz zaufać.</p>
<p>A jeśli czujesz, że to, co czytasz, jest w zgodzie z Tobą — być może właśnie się
odnaleźliśmy.
</p>



    </b>
</div>

                </InfoWrapper>
            </InfoContainer3>
            <Footer />
        </>
    )
}

export default Home